import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isConnected: false,
  messages: [],
  error: null,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    connectionEstablished: (state) => {
      state.isConnected = true;
      state.error = null;
    },
    connectionLost: (state) => {
      state.isConnected = false;
    },
    messageReceived: (state, action) => {
      state.messages.push(action.payload);
    },
    connectionError: (state, action) => {
      state.error = action.payload;
    },
    clearMessages: (state) => {
      state.messages = [];
    },
  },
});

export const {
  connectionEstablished,
  connectionLost,
  messageReceived,
  connectionError,
  clearMessages,
} = websocketSlice.actions;

export const selectWebSocketStatus = (state) => state.websocket.isConnected;
export const selectWebSocketMessages = (state) => state.websocket.messages;
export const selectWebSocketError = (state) => state.websocket.error;

export default websocketSlice.reducer;
